// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screener-save-dialog {
  box-sizing: border-box;
  position: absolute;
  top: calc(100% + 120px);
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  height: 200px;
  border-radius: 4px;
  box-shadow: 0 0 12px 0 var(--box-shadow-primary);
  border: 1px solid var(--border-primary);
  background-color: #fff;
  z-index: 1000;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
}

.screener-save-dialog--mobile-overlay {
  /* The mobile "Saved strategies" list is a fixed, full-screen overlay
     (z-index: 2000) - anchor this above it and center on the viewport
     instead of positioning relative to the (now covered) toolbar. */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2100;
}

.screener-save-dialog-readonly-name {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  margin: 0px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--input-border);
  background-color: var(--tab-filter-off-surface2, #f5f5f5);
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.screener-save-dialog-confirm {
  box-sizing: border-box;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.screener-save-dialog-confirm-text {
  margin: 0px;
  width: 100%;
  text-align: center;
  color: var(--text-subheader);
}

.screener-save-dialog-actions--three {
  flex-direction: row;
  gap: 4px;
}

.screener-save-dialog-compact-button.MuiButton-root {
  box-sizing: border-box;
  height: 36px;
  flex: 1;
  min-width: 0px;
  padding: 0px 4px;
  border: 1px solid var(--color-brand);
  border-radius: 4px;
  background-color: var(--surface-primary);
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 13px;
  line-height: 24px;
  color: var(--color-brand);
  white-space: nowrap;
  box-shadow: none;
  text-transform: none;
}

.screener-save-dialog-compact-button--primary.MuiButton-root {
  background-color: var(--color-brand);
  color: var(--text-invert);
}

.screener-save-dialog-header {
  box-sizing: border-box;
  height: 40px;
  padding-top: 8px;
}

.screener-save-dialog-title {
  margin: 0px;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #1e1f2f;
  text-align: left;
}

.screener-save-dialog-input-wrapper {
  box-sizing: border-box;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: flex-start;
}

.screener-save-dialog-input.screener-save-dialog-input .MuiOutlinedInput-root {
  height: 40px;
  padding: 8px;
  background-color: transparent;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  color: #1e1f2f;
}

.screener-save-dialog-input.screener-save-dialog-input
  .MuiOutlinedInput-root.Mui-error {
  color: #ff3b30;
}

.screener-save-dialog-input.screener-save-dialog-input
  .MuiOutlinedInput-root
  input {
  padding: 0px 0px 0px 8px;
}

.screener-save-dialog-input.screener-save-dialog-input
  .MuiOutlinedInput-root
  fieldset {
  border: 2px solid var(--input-border);
}

.screener-save-dialog-input.screener-save-dialog-input
  .MuiOutlinedInput-root:hover
  fieldset {
  border-width: 2px;
  border-color: var(--color-brand);
}

.screener-save-dialog-input.screener-save-dialog-input
  .MuiOutlinedInput-root.Mui-focused
  fieldset {
  border-color: var(--color-brand);
}

.screener-save-dialog-input.screener-save-dialog-input label {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  color: #bdbdbd;
}

.screener-save-dialog-input.screener-save-dialog-input label.Mui-focused {
  color: #bdbdbd;
}

.screener-save-dialog-input.screener-save-dialog-input .MuiFormHelperText-root {
  color: #ff3b30;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  margin-left: 0px;
}

.screener-save-dialog-input {
  width: 100%;
  height: 40px;
}

.screener-save-dialog-select-ref {
  position: relative;
}

.screener-save-dialog-select-wrapper {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.screener-save-dialog-select-button.screener-save-dialog-select-button {
  position: relative;
  width: 100%;
  height: 40px;
  padding: 8px 8px 8px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 2px solid var(--input-border);
  border-radius: 4px;
  text-transform: none;
}

.screener-save-dialog-select-text {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  color: #000000;
}

.screener-save-dialog-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  background-color: #ffffff;
  padding: 8px 0;
  box-shadow: 0 0 12px 0 var(--box-shadow-primary);
  z-index: 1000;
}

.screener-save-dialog-dropdown-list {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.screener-save-dialog-dropdown-item {
  box-sizing: border-box;
  width: 100%;
  padding: 12px 16px;
  &:hover {
    background-color: var(--tab-filter-off-surface2, #f9e2d6);
  }
}

.screener-save-dialog-dropdown-item-button.screener-save-dialog-dropdown-item-button {
  padding: 0px;
  flex: 1;
  justify-content: start;
  min-width: 0px;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  color: var(--text-primary);
  text-transform: none;
  width: 100%;
  &:hover {
    background-color: unset;
  }
}

.screener-save-dialog-arrow-icon {
  width: 16px;
  height: 16px;
  path {
    fill: var(--accent-primary);
  }
}

.screener-save-dialog-actions {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  background-color: transparent;
}

.screener-save-dialog-ok-button.MuiButton-root {
  flex: none;
  width: 122px;
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Screener/ScreenerSaveDialog/ScreenerSaveDialog.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gDAAgD;EAChD,uCAAuC;EACvC,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;;oEAEkE;EAClE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,yDAAyD;EACzD,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;;EAGE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB;IACE,yDAAyD;EAC3D;AACF;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,sBAAsB;EACtB,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,WAAW;EACX;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".screener-save-dialog {\n  box-sizing: border-box;\n  position: absolute;\n  top: calc(100% + 120px);\n  left: 50%;\n  transform: translateX(-50%);\n  width: 300px;\n  height: 200px;\n  border-radius: 4px;\n  box-shadow: 0 0 12px 0 var(--box-shadow-primary);\n  border: 1px solid var(--border-primary);\n  background-color: #fff;\n  z-index: 1000;\n  padding: 16px 24px;\n  display: flex;\n  flex-direction: column;\n}\n\n.screener-save-dialog--mobile-overlay {\n  /* The mobile \"Saved strategies\" list is a fixed, full-screen overlay\n     (z-index: 2000) - anchor this above it and center on the viewport\n     instead of positioning relative to the (now covered) toolbar. */\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2100;\n}\n\n.screener-save-dialog-readonly-name {\n  box-sizing: border-box;\n  width: 100%;\n  height: 40px;\n  margin: 0px;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid var(--input-border);\n  background-color: var(--tab-filter-off-surface2, #f5f5f5);\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.screener-save-dialog-confirm {\n  box-sizing: border-box;\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.screener-save-dialog-confirm-text {\n  margin: 0px;\n  width: 100%;\n  text-align: center;\n  color: var(--text-subheader);\n}\n\n.screener-save-dialog-actions--three {\n  flex-direction: row;\n  gap: 4px;\n}\n\n.screener-save-dialog-compact-button.MuiButton-root {\n  box-sizing: border-box;\n  height: 36px;\n  flex: 1;\n  min-width: 0px;\n  padding: 0px 4px;\n  border: 1px solid var(--color-brand);\n  border-radius: 4px;\n  background-color: var(--surface-primary);\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 24px;\n  color: var(--color-brand);\n  white-space: nowrap;\n  box-shadow: none;\n  text-transform: none;\n}\n\n.screener-save-dialog-compact-button--primary.MuiButton-root {\n  background-color: var(--color-brand);\n  color: var(--text-invert);\n}\n\n.screener-save-dialog-header {\n  box-sizing: border-box;\n  height: 40px;\n  padding-top: 8px;\n}\n\n.screener-save-dialog-title {\n  margin: 0px;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  color: #1e1f2f;\n  text-align: left;\n}\n\n.screener-save-dialog-input-wrapper {\n  box-sizing: border-box;\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n}\n\n.screener-save-dialog-input.screener-save-dialog-input .MuiOutlinedInput-root {\n  height: 40px;\n  padding: 8px;\n  background-color: transparent;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0px;\n  color: #1e1f2f;\n}\n\n.screener-save-dialog-input.screener-save-dialog-input\n  .MuiOutlinedInput-root.Mui-error {\n  color: #ff3b30;\n}\n\n.screener-save-dialog-input.screener-save-dialog-input\n  .MuiOutlinedInput-root\n  input {\n  padding: 0px 0px 0px 8px;\n}\n\n.screener-save-dialog-input.screener-save-dialog-input\n  .MuiOutlinedInput-root\n  fieldset {\n  border: 2px solid var(--input-border);\n}\n\n.screener-save-dialog-input.screener-save-dialog-input\n  .MuiOutlinedInput-root:hover\n  fieldset {\n  border-width: 2px;\n  border-color: var(--color-brand);\n}\n\n.screener-save-dialog-input.screener-save-dialog-input\n  .MuiOutlinedInput-root.Mui-focused\n  fieldset {\n  border-color: var(--color-brand);\n}\n\n.screener-save-dialog-input.screener-save-dialog-input label {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0px;\n  color: #bdbdbd;\n}\n\n.screener-save-dialog-input.screener-save-dialog-input label.Mui-focused {\n  color: #bdbdbd;\n}\n\n.screener-save-dialog-input.screener-save-dialog-input .MuiFormHelperText-root {\n  color: #ff3b30;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: 0px;\n  margin-left: 0px;\n}\n\n.screener-save-dialog-input {\n  width: 100%;\n  height: 40px;\n}\n\n.screener-save-dialog-select-ref {\n  position: relative;\n}\n\n.screener-save-dialog-select-wrapper {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.screener-save-dialog-select-button.screener-save-dialog-select-button {\n  position: relative;\n  width: 100%;\n  height: 40px;\n  padding: 8px 8px 8px 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border: 2px solid var(--input-border);\n  border-radius: 4px;\n  text-transform: none;\n}\n\n.screener-save-dialog-select-text {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0px;\n  color: #000000;\n}\n\n.screener-save-dialog-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  box-sizing: border-box;\n  border-radius: 4px;\n  width: 100%;\n  background-color: #ffffff;\n  padding: 8px 0;\n  box-shadow: 0 0 12px 0 var(--box-shadow-primary);\n  z-index: 1000;\n}\n\n.screener-save-dialog-dropdown-list {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.screener-save-dialog-dropdown-item {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px 16px;\n  &:hover {\n    background-color: var(--tab-filter-off-surface2, #f9e2d6);\n  }\n}\n\n.screener-save-dialog-dropdown-item-button.screener-save-dialog-dropdown-item-button {\n  padding: 0px;\n  flex: 1;\n  justify-content: start;\n  min-width: 0px;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0px;\n  color: var(--text-primary);\n  text-transform: none;\n  width: 100%;\n  &:hover {\n    background-color: unset;\n  }\n}\n\n.screener-save-dialog-arrow-icon {\n  width: 16px;\n  height: 16px;\n  path {\n    fill: var(--accent-primary);\n  }\n}\n\n.screener-save-dialog-actions {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  background-color: transparent;\n}\n\n.screener-save-dialog-ok-button.MuiButton-root {\n  flex: none;\n  width: 122px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
